/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { map, retry, switchMap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Component({
  selector: 'well-save-as-pdf',
  templateUrl: './save-as-pdf.component.html',
  styleUrls: ['./save-as-pdf.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class SaveAsPdfComponent {
  @Input() fileName: string | undefined = undefined;
  @Output() countNrOfPages = new EventEmitter<number>();
  private readonly htmlToPdfUrl: string | undefined = undefined;

  constructor(
    private readonly elemRef: ElementRef,
    private readonly http: HttpClient,
    environmentService: EnvironmentService
  ) {
    this.htmlToPdfUrl = environmentService.getEnvironmentProperty('htmlToPdfUrl');
  }

  public download(): void {
    this.getBlob()?.subscribe((blob) => {
      this.createDownloadLink(blob);
    });
  }

  public getBlob(): Observable<Blob> | null {
    const shadowRoot = this.elemRef.nativeElement.shadowRoot;
    const html = shadowRoot.innerHTML;
    const headers = new HttpHeaders({
      'Content-Type': 'text/html',
      'Access-Control-Allow-Origin': '*',
    });

    if (html && this.htmlToPdfUrl) {
      return this.http
        .post(this.htmlToPdfUrl, html, {
          headers,
          responseType: 'blob',
          observe: 'response',
        })
        .pipe(
          map((res) => res.body),
          switchMap((res) => {
            if (!res || res.size === 0) {
              return throwError(() => new Error('Empty PDF response'));
            }
            return of(res);
          }),
          retry(2)
        );
    }
    return null;
  }

  createDownloadLink(file: Blob) {
    const link = document.createElement('a');
    link.href = window.URL?.createObjectURL(file);
    link.download = this.fileName ?? 'download.pdf';
    link.click();
  }
}
